module.exports = __webpack_public_path__ + "assets/img/INICIO_1.b18afa8c.svg";